import { FC, Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Modal } from 'ui-library';
import { useClientProfile } from 'prodivers/clientProfile';
import useHistoryBlock from 'hooks/useHistoryBlock';

// Define the shape of the navigation state
interface NavigationState {
    fromTab?: string;
    fromOrigin?: string;
    [key: string]: any; // Allow for other dynamic state properties
}

interface CloseClientProps {
    url: string;
    state?: NavigationState | null;
}

const CloseClient: FC<CloseClientProps> = ({ url, state = null }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    // Client Provider - Assuming useClientProfile returns an object with clientName
    const { clientName } = useClientProfile() as { clientName: string };

    /**
     * @param pathProp - The target path the user is trying to navigate to
     * @param pathState - The state associated with that navigation attempt
     * @param setOpenModal - Function to control the modal visibility state in the hook
     */
    const confirmCloseClient = (
        pathProp: string,
        pathState: NavigationState,
        setOpenModal: Dispatch<SetStateAction<boolean>>,
    ): void => {
        // todo fix me[AT-638]
        const isNextOnBoarding = new RegExp('/onboarding').test(pathProp);

        const modalContent = isNextOnBoarding
            ? t('clientDashboard.startOnBoarding')
            : t('clientDashboard.closeModalText');

        const modalTitle = isNextOnBoarding
            ? t('clientDashboard.startOnBoarding.title')
            : t('clientDashboard.close');

        setOpenModal(true);

        Modal.confirm({
            title: `${modalTitle} ${clientName}`,
            content: modalContent,
            triggerCancelOnClose: true,
            okText: t('clientDashboard.confirm'),
            onOk: () => {
                // TODO: use new approach for window block
                // history.block(true);
                navigate(
                    state?.fromOrigin || pathProp,
                    {
                        state: {
                            ...state,
                            ...pathState,
                            fromTab: pathState?.fromTab,
                        },
                    },
                );
                setOpenModal(false);
            },
            onCancel: async () => {
                await setOpenModal(false);
            },
            cancelText: t('clientDashboard.cancel'),
            className: 'close-client-modal',
        });
    };

    // The hook likely handles the interception logic
    useHistoryBlock(url, confirmCloseClient);

    return null;
};

export default CloseClient;
